export const loadingI18n = {
  en: {
    retry: 'Try again',
    startupError: 'PEXIFY could not start.',
    status: 'Loading',
  },
  tr: {
    retry: 'Tekrar dene',
    startupError: 'PEXIFY başlatılamadı.',
    status: 'Yükleniyor',
  },
} as const
